import { OPTOUT as CONSENTS_SETTINGS } from './customer/default/common.constants';

export const AUDIO = 'audio';
export const BOOKMARK = 'bookmark';
export const UNBOOKMARK = 'unbookmark';
export const LIVE = 'live';
export const LIVES = 'lives';
export const PROGRAM = 'program';
export const SEASON = 'season';
export const VIDEO = 'video';
export const SERVICE = 'service';
export const HOME_ALIAS = 'alias';
export const SERVICES = 'services';
export const PROFILE = 'account';
export const SEARCH = 'search';
export const SETTINGS = 'settings';
export const FOLDERS = 'folders';
export const FOLDER = 'folder';
export const CLOSE = 'close';
export const SIDENAV = 'sidenav';
export const NAV_BACK = 'backNavigation';
export const EXPLORE = 'explore';
export const DISCONNECT_FOCUS_NAME = 'disconnectButton';
export const AVATAR_LIST_FOCUS_NAME = 'avatarList';
export const LAYOUT_FIRST_BLOCK = 'block_0';
export const LOCK = 'lock';
export const LOGOUT = 'logout';
export const FRONTSPACE = 'frontspace';
export const PROFILES_GATE = 'profilesgate';
export const PLAY = 'play';
export const RADIO = 'radio';

// PROFILE
export const BOOKMARKS = 'account_bookmarks';
export const ACCOUNT_SETTINGS = 'account_settings';
export const INFORMATION = 'account_informations';
export const OPTOUT = CONSENTS_SETTINGS;
export const USAGE_TERMS = 'tos';
export const LEGAL_CONDITIONS = 'account_legalconditions';
export const ACCESSIBILITY_STATEMENT = 'accessibility_statement';
export const PRIVACY_POLICY = 'privacy_policy';
export const HELP = 'help';
export const FEEDBACK = 'feedback';
export const SUBSCRIPTION_TERMS = 'termsofsubscription';

// Device sizes
export const HD = 'HD';
export const FULL_HD = 'FULL_HD';
export const ULTRA_HD = 'ULTRA_HD';

// Rendering contexts template properties (sizes, image options) can be defined
// for. Every template must define DEFAULT; other contexts fall back to DEFAULT
// when not defined
export const RENDERING_CONTEXT = {
  GENERAL: 'general',
  SEARCH: 'search',
};
